export function initMemberLetterFollowup(Livewire) {
  let pending = null
  const matches = payload => pending && payload?.resourceClass === pending.resourceClass &&
    JSON.stringify(payload?.modelIds) === JSON.stringify(pending.modelIds)
  const executed = Livewire.on('action-executed', payload => {
    if (matches(payload)) pending = null
    const dialog = payload?.response?.member_letter_dialog
    if (
      !['App\\Resources\\Person', 'App\\Resources\\RegistrationApplication'].includes(payload?.resourceClass) ||
      dialog?.resourceClass !== 'App\\Resources\\Person' ||
      dialog?.name !== 'print_person_letter' ||
      !Array.isArray(dialog?.modelIds) || dialog.modelIds.length === 0 ||
      !dialog.modelIds.every(id => Number.isSafeInteger(id) && id > 0)
    ) return

    pending = dialog
    Livewire.dispatch('showActionDialog', dialog)
  })
  const cancelled = Livewire.on('resourcerer-action-dialog-cancelled', payload => {
    if (!matches(payload) || payload?.actionName !== 'print_person_letter') return
    const redirect = pending.redirectAfter
    pending = null
    if (!redirect) return
    const target = new URL(redirect, window.location.href)
    if (target.origin === window.location.origin) Livewire.navigate(target.href)
  })
  return () => {
    pending = null
    executed()
    cancelled()
  }
}
